import { BookOpen } from "lucide-react";

export const Header = () => (
  <header className="gp-header" data-testid="nav-header">
    <div className="tricolour-bar" />
    <div className="gp-container flex items-center justify-between py-3">
      <a href="#top" className="flex items-center gap-2" data-testid="brand-logo">
        <span className="brand-mark"><BookOpen size={20} /></span>
        <span className="leading-tight">
          <span className="block font-hi font-bold text-[15px] text-white">ग्राम पाठशाला मानपुर</span>
          <span className="block text-[11px] tracking-widest uppercase text-white/50">Gram Pathshala Manpur</span>
        </span>
      </a>
      <a href="/#register" className="btn-saffron btn-sm" data-testid="nav-register-btn">
        Register
      </a>
    </div>
  </header>
);
